import { getShapeDividersCSSVars } from '../../core/carmi/ShapeDividers/ShapeDividers.mapper'
import type { StripColumnsContainerCss, StripColumnsContainerDefinition } from '@wix/thunderbolt-components-native'
import { withCompInfo } from '@wix/editor-elements-integrations'
import { getFillLayersCSSVars } from '../../core/mappers/FillLayers/FillLayers.utils'

export const css = withCompInfo<StripColumnsContainerCss, StripColumnsContainerDefinition>()(
	[
		'hasResponsiveLayout',
		'compDesign',
		'compProps',
		'experiments',
		'isMobileView',
		'siteColors',
		'viewMode',
		'compId',
		// @ts-ignore - Remove once siteWidth is added to the compInfo
		'siteWidth',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
	],
	({
		hasResponsiveLayout,
		compDesign,
		compProps,
		experiments,
		isMobileView,
		siteColors,
		viewMode,
		compId,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once siteWidth is added to the compInfo
		siteWidth,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
	}) => {
		const backgroundMedia = compDesign.background ?? {}

		const minWidth = isMobileView && { 'min-width': `${siteWidth}px` }

		const dividersCSSVars = getShapeDividersCSSVars({
			compId,
			hasResponsiveLayout,
			isMobileView,
			compDesign,
		})

		const fillLayersCss = getFillLayersCSSVars({
			animations,
			backgroundMedia,
			compId,
			compDesign,
			compProps,
			experiments,
			isMobileView,
			isNonAdaptiveMobile,
			siteColors,
			viewMode,
		})

		return {
			...dividersCSSVars,
			...fillLayersCss,
			'--padding': `${compProps.rowMargin}px`,
			'--margin': `${compProps.columnsMargin}px`,
			...minWidth,
		}
	}
)
